import { render, staticRenderFns } from "./ContentArticleOverviewBlock.vue?vue&type=template&id=0ebc388f"
import script from "./ContentArticleOverviewBlock.vue?vue&type=script&lang=js"
export * from "./ContentArticleOverviewBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentArticleOverviewBlock.vue?vue&type=style&index=0&id=0ebc388f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports